import * as categoryActions from '../../actions/categories';
import * as fetchingState from '../../constants/fetchingState';

export default function (state, action) {

    switch (action.type) {
        case categoryActions.FETCH_CATEGORIES: {
            return { ...state, fetching: fetchingState.FETCHING };
        }
        case categoryActions.SUCCESS_FETCH_CATEGORIES: {
            if (!action.data.error)
                return { ...state, fetching: fetchingState.FETCHED, categories: action.data };
        }
        case categoryActions.FAILURE_FETCH_CATEGORIES: {
            return { ...state, fetching: fetchingState.FAILED };
        }
        case categoryActions.UPDATE_CATEGORY: {
            return { ...state, updateFetching: fetchingState.FETCHING };
        }
        case categoryActions.SUCCESS_UPDATE_CATEGORY: {
            if (!action.data.error)
                return { ...state, updateFetching: fetchingState.FETCHED };
        }
        case categoryActions.FAILURE_UPDATE_CATEGORY: {
            return { ...state, updateFetching: fetchingState.FAILED, updateResult: action.data.error };
        }
        case categoryActions.CREATE_CATEGORY: {
            return { ...state, createFetching: fetchingState.FETCHING };
        }
        case categoryActions.SUCCESS_CREATE_CATEGORY: {
            if (!action.data.error)
                return { ...state, createFetching: fetchingState.FETCHED };
        }
        case categoryActions.FAILURE_CREATE_CATEGORY: {
            return { ...state, createFetching: fetchingState.FAILED, createResult: action.data.error };
        }
        case categoryActions.CLEAR_CREATE_CATEGORY: {
            return { ...state, createFetching: fetchingState.INITIAL, createResult: undefined };
        }
        case categoryActions.CLEAR_UPDATE_CATEGORY: {
            return { ...state, updateFetching: fetchingState.INITIAL, updateResult: undefined };
        }
        default: return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/serviceCategory/categoryReducer.js